import { render, staticRenderFns } from "./SnippetManager.vue?vue&type=template&id=1ac11059"
import script from "./SnippetManager.vue?vue&type=script&lang=js"
export * from "./SnippetManager.vue?vue&type=script&lang=js"
import style0 from "./SnippetManager.vue?vue&type=style&index=0&id=1ac11059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports